import uuid from 'node-uuid';
import { head } from 'lodash';
import {
	TYPE_BACS_CREDIT,
	TYPE_BACS_DEBIT,
	TYPE_FASTER_PAYMENTS,
	TYPE_IFT,
	TYPE_DOMESTIC_PAYEE,
	TYPE_IFT_PAYEE,
	TYPE_CHAPS,
} from '../../config';
import { getPaymentTypeOrPayeeType } from '../modes/selectors';
import { getCalendarDates } from '../calendar/selectors';

export const GO_TO_PAYMENTS_PAGE = 'GO_TO_PAYMENTS_PAGE';
export const GO_TO_PAYMENTS_LANDING_PAGE = 'GO_TO_PAYMENTS_LANDING_PAGE';
export const GO_TO_DEBIT_PAYMENTS_PAGE = 'GO_TO_DEBIT_PAYMENTS_PAGE';
export const GO_TO_CREDIT_LANDING_PAGE = 'GO_TO_CREDIT_LANDING_PAGE';
export const GO_TO_DEBIT_LANDING_PAGE = 'GO_TO_DEBIT_LANDING_PAGE';
export const CREATE_NEW_BACS_TEMPLATE = 'CREATE_NEW_BACS_TEMPLATE';

export const RESET_APP = 'RESET_APP';

export const GO_BACK_PAGE = 'GO_BACK_PAGE';
export const GO_TO_REVIEW = 'GO_TO_REVIEW';
export const GO_TO_PAYMENTS = 'GO_TO_PAYMENTS';
export const CREATE_NEW_FASTER_PAYMENT_TEMPLATE = 'CREATE_NEW_FASTER_PAYMENT_TEMPLATE';
export const GO_TO_ADD_PAYEE_LANDING_PAGE = 'GO_TO_ADD_PAYEE_LANDING_PAGE';
export const SET_BACK_PAGE = 'SET_BACK_PAGE';
export const GO_TO_PAGE = 'GO_TO_PAGE';
export const GO_TO_PREVIOUS_PAGE = 'GO_TO_PREVIOUS_PAGE';
export const GO_TO_IMPORT_PAYEES_PAGE = 'GO_TO_IMPORT_PAYEES_PAGE';
export const SET_SHARED_DATA = 'SET_SHARED_DATA';

export const pages = {
	IFTLandingPage: 'IFTLandingPage',
	IFTPayments: 'IFTPayments',
	IFTPayeeSelector: 'IFTPayeeSelector',
	IFTAccountPicker: 'IFTAccountPicker',
	IFTPaymentDetails: 'IFTPaymentDetails',
	IFTReview: 'IFTReview',
	IFTSubmitted: 'IFTSubmitted',
	ChapsLandingPage: 'ChapsLandingPage',
	ChapsPayeeSelector: 'ChapsPayeeSelector',
	ChapsAccountPicker: 'ChapsAccountPicker',
	ChapsPayments: 'ChapsPayments',
	ChapsReview: 'ChapsReview',
	ChapsSubmitted: 'ChapsSubmitted',
	BacsImportedCreditPaymentPage: 'BacsImportedCreditPayments',
	BacsImportedDebitPaymentPage: 'BacsImportedDebitPayments',
	BacsCreditPayeeSelector: 'BacsCreditPayeeSelector',
	BacsDebitPayeeSelector: 'BacsDebitPayeeSelector',
	BacsCreditAccountPicker: 'BacsCreditAccountPicker',
	BacsDebitAccountPicker: 'BacsDebitAccountPicker',
	FasterPayments: 'Payments',
	FasterPaymentsPayeeSelector: 'FasterPaymentsPayeeSelector',
	FasterPaymentsAccountPicker: 'FasterPaymentsAccountPicker',
	FasterPaymentsReview: 'Review',
	FasterPaymentsSubmitted: 'Confirmed',
	FasterPaymentsLandingPage: 'PaymentsLandingPage',
	ImportedFasterPaymentsPage: 'ImportedFasterPayments',
	ImportedChapsPaymentsPage: 'ImportedChapsPayments',
	BacsCreditLanding: 'BacsCreditLanding',
	BacsCreditPayments: 'BacsCreditPayments',
	BacsCreditReview: 'BacsCreditReview',
	BacsCreditSubmitted: 'BacsCreditSubmitted',
	BacsDebitLanding: 'BacsDebitLanding',
	BacsDebitPayments: 'BacsDebitPayments',
	BacsDebitReview: 'BacsDebitReview',
	BacsDebitSubmitted: 'BacsDebitSubmitted',
	Payee: 'Payee',
	RetailPayment: 'RetailPayment',
	RetailReview: 'RetailReview',
	RetailSubmitted: 'RetailSubmitted',
	EffectiveWarning: {
		paymentReason: 'EwPaymentReason',
		review: 'EwReview',
		warning: 'Warning',
		submitted: 'Submitted',
		paymentCancelled: 'PaymentCancelled',
	},
	COP: {
		MakeMatch: 'MakeMatch',
		CloseMatch: 'CloseMatch',
		MatchMade: 'MatchMade',
		AccountWarning: 'AccountWarning',
		NoMatch: 'NoMatch',
		ServiceDown: 'ServiceDown',
		Blocked: 'Blocked',
		CreateAccountError: 'CreateAccountError',
		CreateTemplateError: 'CreateTemplateError',
	},
};

export const getLandingPage = (type) => {
	const backPage = [];
	switch (type) {
		case TYPE_BACS_CREDIT:
			return { name: pages.BacsCreditLanding, backPage };
		case TYPE_BACS_DEBIT:
			return { name: pages.BacsDebitLanding, backPage };
		case TYPE_FASTER_PAYMENTS:
		case TYPE_DOMESTIC_PAYEE:
			return { name: pages.FasterPaymentsLandingPage, backPage };
		case TYPE_IFT_PAYEE:
		case TYPE_IFT:
			return { name: pages.IFTLandingPage, backPage };
		case TYPE_CHAPS:
			return { name: pages.ChapsLandingPage, backPage };
		default:
			return {};
	}
};

export const goToReview = () => ({
	type: GO_TO_REVIEW,
});

export const goToPayments = () => ({
	type: GO_TO_PAYMENTS,
});
export const goToPaymentsLanding = ({ paymentType }) => ({
	type: GO_TO_PAYMENTS_LANDING_PAGE,
	page: getLandingPage(paymentType),
	meta: {
		allowedDuringApiCall: true,
	},
});

export const createNewFasterPaymentTemplate = () => ({
	type: CREATE_NEW_FASTER_PAYMENT_TEMPLATE,
});

export const goBackPage = () => ({
	type: GO_BACK_PAGE,
});

export const goToPaymentsPage = () => ({
	type: GO_TO_PAYMENTS_PAGE,
});

export const goToDebitPaymentsPage = () => ({
	type: GO_TO_DEBIT_PAYMENTS_PAGE,
});

export const goToCreditLandingPage = () => ({
	type: GO_TO_CREDIT_LANDING_PAGE,
});

export const goToDebitLandingPage = () => ({
	type: GO_TO_DEBIT_LANDING_PAGE,
});

export const createNewBacsTemplate = (bacsType) => ({
	type: CREATE_NEW_BACS_TEMPLATE,
	id: uuid.v1(),
	bacsType,
});

export const resetApp = (dispatch, getState) => {
	const state = getState();
	const firstDate = head(getCalendarDates(state));
	const paymentType = getPaymentTypeOrPayeeType(state);
	dispatch(goToPaymentsLanding({ paymentType }));
	// TODO: Could move firstDate resolution to the relevant reducers who need it. Also, possibly unnecessary as Landing page components
	// will perform their own reset.
	return dispatch({
		type: RESET_APP,
		firstDate,
		meta: {
			allowedDuringApiCall: true,
		},
	});
};

export const goToAddNewPayeePage = () => ({
	type: GO_TO_ADD_PAYEE_LANDING_PAGE,
});

export const setBackPage = (backPage) => ({
	type: SET_BACK_PAGE,
	backPage,
});

export const goToPage = (name) => ({
	type: GO_TO_PAGE,
	name,
	meta: {
		allowedDuringApiCall: true,
	},
});

export const goToPreviousPage = () => ({
	type: GO_TO_PREVIOUS_PAGE,
});

export const goToImportPayeesPage = (importedPayeesList) => ({
	type: GO_TO_IMPORT_PAYEES_PAGE,
	payload: importedPayeesList,
});

export const setSharedData = (data) => ({
	type: SET_SHARED_DATA,
	data,
});

export const handleGoToPayments = () => (dispatch, getState) => {
	const state = getState();
	const paymentTypeOrPayeeType = getPaymentTypeOrPayeeType(state);
	switch (paymentTypeOrPayeeType) {
		case TYPE_BACS_CREDIT: {
			dispatch(goToPaymentsPage());
			break;
		}
		case TYPE_BACS_DEBIT: {
			dispatch(goToDebitPaymentsPage());
			break;
		}
		case TYPE_FASTER_PAYMENTS: {
			dispatch(goToPayments());
			break;
		}
		case TYPE_CHAPS: {
			dispatch(goToPage(pages.ChapsPayments));
			break;
		}
		case TYPE_IFT: {
			dispatch(goToPage(pages.IFTPayments));
			break;
		}
		default:
			break;
	}
};
